// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_mi-0";